import { AssignOvertimeCombinationModel } from './@types/CombinationRuleModel';
import { CombinationRuleDB, CombinationRuleCreate, CombinationRuleParUpdate, CombinationRuleUpdate } from './@types/CombinationRuleModel';
//import { jwtDecode } from "jwt-decode";
export class CombinationRuleRepository {
    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getCombinations(): Promise<CombinationRuleDB[]> {
        try {
            const response = await this.httpService.get<TKResponses<CombinationRuleDB>>('/combination_rules');
            const combinations = response.data.map((combinationRule: CombinationRuleDB) => ({
                ...combinationRule,
                id: combinationRule.combination_rule_id,
            }));
            return combinations.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
        } catch (error) {
            console.error('Error fetching combination rules:', error);
            throw error;
        }
    }

    async getCombination(id: number): Promise<CombinationRuleDB> {
        try {
            const response = await this.httpService.get<TKResponse<CombinationRuleDB>>(`/combination_rules/?combination_rule_id__in=${id}`);
            return {
                ...response.data,
                id: response.data.combination_rule_id,
            };
        } catch (error) {
            console.error('Error fetching combination rule:', error);
            throw error;
        }
    }

    async getCombinationPares(id: number): Promise<CombinationRuleDB[]> {
        try {
            const response = await this.httpService.get<TKResponses<CombinationRuleDB>>(`/combination_rules/${id}/combinations`);
            return response.data;
        } catch (error) {
            console.error('Error fetching combination pares:', error);
            throw error;
        }
    }

    async createCombination(combination: CombinationRuleCreate): Promise<{ data: CombinationRuleDB; status: number }> {
        try {
            const response = await this.httpService.post<CombinationRuleDB, CombinationRuleCreate>('/combination_rules', { data: combination });
            return { data: response, status: 200 };
        } catch (error) {
            console.error('Error creating combination rule:', error);
            throw error;
        }
    }

    async asignarCombination(combinations: CombinationRuleParUpdate[]): Promise<{ data: CombinationRuleDB[]; status: number }> {
        try {
            const requests = combinations.map((combination: CombinationRuleParUpdate) =>
                this.httpService.patch<CombinationRuleDB, CombinationRuleParUpdate>(`/combination_rules/${combination.combination_rule_id}/combinations/${combination.id}`, { data: combination }),
            );
            return { data: await Promise.all(requests), status: 200 };
        } catch (error: any) {
            return { data: error, status: 500 };
        }
    }

    async deleteCombination(id: number): Promise<number> {
        try {
            await this.httpService.delete<number>(`/combination_rules/${id}`);
            return id;
        } catch (error: any) {
            console.error('Error deleting combination rule:', error);
            throw error;
        }
    }

    async updateCombination(combination_rule_data: CombinationRuleUpdate): Promise<{ data: CombinationRuleDB; status: number }> {
        try {
            const response = await this.httpService.patch<CombinationRuleDB, CombinationRuleUpdate>(`/combination_rules/${combination_rule_data.combination_rule_id}`, { data: combination_rule_data });
            return { data: response, status: 200 };
        } catch (error: any) {
            console.error('Error updating combination rule:', error);
            throw error;
        }
    }

    async assignOvertimeCombination(combination_rule_id: number, data: any[]): Promise<{ data: AssignOvertimeCombinationModel; status: number }> {
        try {
            const payload = { data: data };
            const response = await this.httpService.post<TKResponse<AssignOvertimeCombinationModel>, { data: any[] }>(`/combination_rules/${combination_rule_id}/overtime`, { data: payload });
            return { data: response.data, status: 200 };
        } catch (error: any) {
            console.error('Error assigning overtime combination:', error);
            throw error;
        }
    }

    async getOvertimeCombination(combination_rule_id: number): Promise<{ data: any[]; status: number }> {
        try {
            const response = await this.httpService.get<TKResponse<any[]>>(`/combination_rules/${combination_rule_id}/overtime`);
            return { data: response.data, status: 200 };
        } catch (error: any) {
            console.error('Error fetching overtime combination:', error);
            throw error;
        }
    }
    async getDistributionCombination(combination_rule_id: number): Promise<{ data: any[]; status: number }> {
        try {
            const response = await this.httpService.get<TKResponse<any[]>>(`/combination_rules/${combination_rule_id}/distributions`);
            return { data: response.data, status: 200 };
        } catch (error: any) {
            console.error('Error fetching distribution combination:', error);
            throw error;
        }
    }
}
